import { render, staticRenderFns } from "./bulkCalls.vue?vue&type=template&id=d05c76ce&scoped=true"
import script from "./bulkCalls.vue?vue&type=script&lang=js"
export * from "./bulkCalls.vue?vue&type=script&lang=js"
import style0 from "./bulkCalls.vue?vue&type=style&index=0&id=d05c76ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05c76ce",
  null
  
)

export default component.exports